export default "__VITE_ASSET__nKu7dUy_Rjg5ysps7E8aBA__"